import React, { useState } from 'react';
import { menuUtil } from 'modules/common';
import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { RemoveInstallationModal } from 'modules/components/layer17';



export type InstallationMenuProps = menuUtil.IBaseMenuProps & {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationMenuProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >

        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DELETE'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Remove Selection
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isVisible && (
        <RemoveInstallationModal.FC
          id={props.id}
          handleClose={props.handleClose}
          isVisible={isVisible}
          preventNavigation={true}
        />
      )}
    </>
  );
};
